import axios from 'axios';

// Frontend (Firebase Hosting) and backend (Compute Engine) are on separate origins,
// so unlike the old Vercel setup we need an absolute API URL rather than same-origin
// relative paths. Empty string in dev — package.json's "proxy" handles localhost.
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Most components call axios.get('/api/...') directly rather than through getApiUrl()
// below. Since this module is imported once at app boot (index.js) and `axios` here is
// the same package singleton every file imports, setting defaults.baseURL here makes
// those relative calls resolve against the API origin too, not just calls that use
// getApiUrl() explicitly.
axios.defaults.baseURL = API_BASE_URL;

export const getApiUrl = (path) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${API_BASE_URL}${cleanPath}`;
};

export default axios;
